// Path: ./src/app/components/ImagePreviewModal/index.tsx
import React, { useState } from "react";
import { IconButton, Modal, Box, CardMedia } from "@mui/material";
import { ImageModalWrapper } from "./styled";
import FitScreenSharpIcon from "@mui/icons-material/FitScreenSharp";

/**
 * ImagePreviewModal is a component that displays a modal with a larger view of an image.
 * The modal is triggered by clicking on an IconButton.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The child nodes of the component.
 * @param {string} props.src - The source URL of the image to display in the modal.
 */
export function ImagePreviewModal({
  children,
  src,
  zIndex = 1600,
}: {
  children: React.ReactNode;
  src: string;
  zIndex?: number;
}) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <ImageModalWrapper data-testid="imagepreviewmodal-test-id">
      {children}
      <IconButton
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          color: "#999393c2",
          zIndex: 4,
        }}
        onClick={handleOpen}
      >
        <FitScreenSharpIcon fontSize="small" />
      </IconButton>
      <Modal open={open} onClose={handleClose} sx={{ zIndex }}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
          }}
        >
          <CardMedia
            component="img"
            height="100%"
            width="100%"
            image={src}
            alt={"Product image"}
          />
        </Box>
      </Modal>
    </ImageModalWrapper>
  );
}

export default ImagePreviewModal;
